import Button from 'antd/lib/button'
import ModalComp from 'Components/common/Modal/Modal'
import WarningIcon from 'Assets/icons/warning.svg'
import CloseCircle from 'Assets/icons/close-circle.svg'
import InfoCircle from 'Assets/icons/info-circle.svg'
import { ViolationsType } from 'shared/violations/types'
import { flattenViolation } from 'Utils/common.utils'
import styles from './WarningModal.module.less'

export type WarningModalProps = {
    getVisibility: () => boolean
    getViolation: ViolationsType
    closable?: boolean
    onConfirm: () => void
    onCancel?: () => void
}

export const WarningModal: React.FC<WarningModalProps> = props => {
    const violationsList = flattenViolation(props.getViolation)

    return (
        <div data-testid="warning-modal-wrapper">
            <ModalComp
                visible={props.getVisibility()}
                modalHeader={
                    <div className={styles['modal-header']}>
                        <img src={WarningIcon} alt="Warning" />
                        <div className={styles['modal-header-title']}>
                            Cannot submit with violations
                        </div>
                    </div>
                }
                modalFooter={
                    <div className={'modal-button'}>
                        {props.closable ? '' : <Button onClick={props.onCancel}>Cancel</Button>}
                        <Button type="primary" onClick={props.onConfirm}>
                            Ok
                        </Button>
                    </div>
                }
                onCancel={props.onCancel}
                closable={props.closable}
            >
                <div className={styles['modal-container-parent']}>
                    <span>Fix the following violations to submit:</span>
                    <div className={styles['modal-container']}>
                        {violationsList.map(val => (
                            <div key={val.id} className={styles['modal-container-list']}>
                                <img
                                    className={styles['modal-container-list-icon']}
                                    src={val.type === 'warning' ? InfoCircle : CloseCircle}
                                    alt={val.type === 'warning' ? 'Warning' : 'Error'}
                                />
                                <span className={styles['modal-container-list-text']}>
                                    {val.message}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </ModalComp>
        </div>
    )
}
